import { render } from "./ticketsThrow.vue?vue&type=template&id=1ab631b0"
import script from "./ticketsThrow.vue?vue&type=script&setup=true&lang=js"
export * from "./ticketsThrow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/exhibitionManage/ticketsThrow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ab631b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ab631b0', __exports__)) {
    console.log('reload')
    api.reload('1ab631b0', __exports__)
  }
  
  module.hot.accept("./ticketsThrow.vue?vue&type=template&id=1ab631b0", () => {
    console.log('re-render')
    api.rerender('1ab631b0', render)
  })

}


export default __exports__